import { useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-canvas to-canvas flex justify-center">
      <div className="w-full max-w-md px-6 py-8">
        <button
          onClick={() => navigate('/')}
          className="font-body text-lime text-sm mb-6 inline-flex items-center gap-1"
        >
          &larr; Back to Suppertide
        </button>

        <h1 className="font-display text-3xl font-semibold text-ink mb-2">
          Terms of Service
        </h1>
        <p className="font-body text-ink-soft text-sm mb-6">
          Effective February 15, 2026
        </p>

        <div className="space-y-4">
          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Acceptance of Terms
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              By accessing or using Suppertide, you agree to be bound by these
              Terms of Service and our{' '}
              <a href="/privacy" className="text-lime underline">
                Privacy Policy
              </a>
              . If you do not agree, do not use the service.
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Description of Service
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              Suppertide is a family meal planning progressive web application.
              Members of a household swipe to rank meals, and the app generates
              weighted weekly meal plans, shopping lists, and cooking directions.
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Accounts
            </h2>
            <ul className="font-body text-ink-soft text-sm leading-relaxed list-disc pl-4 space-y-1">
              <li>One account per email address.</li>
              <li>
                Access is household-based. You may invite other members to your
                household.
              </li>
              <li>
                You are responsible for maintaining the security of your account
                and all activity under it.
              </li>
              <li>
                You must be at least 13 years old to create an account. Parents
                or guardians manage accounts and child profiles on behalf of
                children under 13.
              </li>
            </ul>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              User Content
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              Recipes, images, and feedback you submit are user-generated
              content. You retain ownership of your content. By using Suppertide,
              you grant us a limited license to store, display, and process your
              content solely for the purpose of operating the service.
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Acceptable Use
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed mb-2">
              You agree not to:
            </p>
            <ul className="font-body text-ink-soft text-sm leading-relaxed list-disc pl-4 space-y-1">
              <li>Abuse, harass, or harm other users.</li>
              <li>
                Scrape, crawl, or use automated means to access the service.
              </li>
              <li>
                Attempt unauthorized access to other accounts or our
                infrastructure.
              </li>
              <li>
                Use the service for any unlawful purpose or in violation of
                these terms.
              </li>
            </ul>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Termination
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              You may delete your account at any time. We may suspend or
              terminate your access if you violate these terms. Upon
              termination, your data will be deleted in accordance with our{' '}
              <a href="/privacy" className="text-lime underline">
                Privacy Policy
              </a>
              .
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Disclaimers
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              Recipes and meal plans are provided for informational purposes
              only and do not constitute medical or dietary advice. We make no
              warranty regarding the accuracy of nutritional data. Always
              consult a qualified professional for dietary or allergy-related
              concerns. The service is provided &ldquo;as is&rdquo; without
              warranties of any kind, either express or implied.
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Limitation of Liability
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              To the fullest extent permitted by law, Sophinea and its operators
              shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages, or any loss of profits or
              data, arising from your use of the service.
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Changes to These Terms
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              We may update these terms from time to time. We will notify you
              of changes through the app. Continued use of Suppertide after changes
              constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="bg-panel rounded-2xl p-5 border border-hairline">
            <h2 className="font-display text-lg font-bold text-ink mb-2">
              Contact Us
            </h2>
            <p className="font-body text-ink-soft text-sm leading-relaxed">
              If you have questions about these terms, contact us at{' '}
              <a
                href="mailto:hello@suppertide.com"
                className="text-lime underline"
              >
                hello@suppertide.com
              </a>
              .
            </p>
          </section>
        </div>

        <p className="font-body text-ink-soft text-xs text-center mt-6">
          &copy; 2026 Sophinea. All rights reserved.
        </p>
      </div>
    </div>
  );
}
